import type { PriceAdjustmentUserOverride, TradeAck, TradeRequestPayload } from 'epic/common-form/Trade';
import type { Observable, SchedulerLike } from 'rxjs';
import { map } from 'rxjs/operators';
import type {
  NextTradeAuthorizationResult,
  PriceEnhancement,
  PriceEnhancementMode,
  TradeExecReport,
} from 'state/quotes/trades/trades.model';
import type { IHttpClient } from 'utils/http.old/httpClient.model';

export interface TradeRequestEpicApi {
  requestTrade(payload: TradeRequestPayload): Observable<TradeAck>;
  getTradeAuth(quoteId: string): Observable<NextTradeAuthorizationResult>;
  getTradeExec(quoteId: string): Observable<TradeExecReport>;
}

export function mapPriceAdjustmentUserOverride(
  mode: PriceEnhancementMode,
  enhancement: PriceEnhancement | undefined,
): PriceAdjustmentUserOverride | null {
  if (mode === 'None' || enhancement === undefined) {
    return null;
  }
  const { tradingOffer, xMargin: salesMargin } = enhancement;
  return { tradingOffer, salesMargin };
}

export function tradeRequestApi(
  http: IHttpClient,
  timeoutInMillis: number,
  scheduler?: SchedulerLike,
): TradeRequestEpicApi {
  return {
    requestTrade(payload) {
      return http
        .post<TradeAck>({ url: 'api/v1/quotes/execute', body: payload, timeOut: timeoutInMillis }, scheduler)
        .pipe(map(r => r.payload));
    },
    getTradeAuth(quoteId) {
      return http
        .getJSON<NextTradeAuthorizationResult>({ url: `api/v1/quote/${quoteId}/tradeAuth`, timeOut: timeoutInMillis })
        .pipe(map(r => r.payload));
    },
    getTradeExec(quoteId) {
      return http
        .getJSON<TradeExecReport>({ url: `api/v1/quote/${quoteId}/tradeExec`, timeOut: timeoutInMillis })
        .pipe(map(r => r.payload));
    },
  };
}
